import { queryParams, type RouteQueryOptions, type RouteDefinition, type RouteFormDefinition } from './../../../../wayfinder'
/**
* @see \App\Http\Controllers\PhoneVerificationController::index
* @see app/Http/Controllers/PhoneVerificationController.php:18
* @route '/admin/leads/phone-verifications'
*/
export const index = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: index.url(options),
    method: 'get',
})

index.definition = {
    methods: ["get","head"],
    url: '/admin/leads/phone-verifications',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\PhoneVerificationController::index
* @see app/Http/Controllers/PhoneVerificationController.php:18
* @route '/admin/leads/phone-verifications'
*/
index.url = (options?: RouteQueryOptions) => {
    return index.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\PhoneVerificationController::index
* @see app/Http/Controllers/PhoneVerificationController.php:18
* @route '/admin/leads/phone-verifications'
*/
index.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: index.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\PhoneVerificationController::index
* @see app/Http/Controllers/PhoneVerificationController.php:18
* @route '/admin/leads/phone-verifications'
*/
index.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: index.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\PhoneVerificationController::index
* @see app/Http/Controllers/PhoneVerificationController.php:18
* @route '/admin/leads/phone-verifications'
*/
const indexForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: index.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\PhoneVerificationController::index
* @see app/Http/Controllers/PhoneVerificationController.php:18
* @route '/admin/leads/phone-verifications'
*/
indexForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: index.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\PhoneVerificationController::index
* @see app/Http/Controllers/PhoneVerificationController.php:18
* @route '/admin/leads/phone-verifications'
*/
indexForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: index.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

index.form = indexForm

const phoneVerifications = {
    index: Object.assign(index, index),
}

export default phoneVerifications